<template>
  <div class="height props-group">
    <el-form-item label="高度" prop="properties.height" :rules="rules">
      <el-input v-model.number="component.properties.height" maxlength="3">
        <template slot="append">px</template>
      </el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-height',
  props: ['component'],
  data () {
    let numberValidator = function (rule, value, callback) {
      if (value !== '') {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字'))
        } else {
          if (value < 0) {
            callback(new Error('必须是正数'))
          } else {
            callback()
          }
        }
      } else {
        callback()
      }
    }
    return {
      rules: [
        { validator: numberValidator, trigger: 'blur' }
      ]
    }
  }
}
</script>

<style lang="scss">
  .height {
    border-top: 1px solid #ebebeb;
    .el-input-group__append {
      width: 36px;
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/height.vue